// auth/selectors.ts
import { useAuthStore } from "./authStore";
import { useShallow } from "zustand/react/shallow";

export const useAuthSnapshot = () =>
  useAuthStore(
    useShallow((state) => ({
      user: state.user,
      isAuthenticated: state.isAuthenticated,
      permissions: state.permissions,
    }))
  );

/**
 * Hook that returns auth state ready to be passed to microfrontend components.
 * Uses useShallow so a new object reference is only returned when the
 * individual fields actually change (prevents infinite re-render loops).
 *
 * NOTE: getAccessToken is NOT included here — it's a stable module-level
 * function imported separately, not store state.
 */
export const useShellAuth = () =>
  useAuthStore(
    useShallow((state) => ({
      user: state.user,
      isAuthenticated: state.isAuthenticated,
      permissions: state.permissions,
    }))
  );
